import React, { useState } from "react";

import S from "./strings";
import { TabProps } from "./helpers";
import { DeepLink } from "./enrollmentUpdatesController";
import UnaAlumna from "./unaAlumna";
import UnHorario from "./unHorario";

/** Actualizar: una alumna o un horario completo. Cada quien arranca donde lo dejó el enlace que la abrió. */
const ActualizarTab: React.FC<TabProps & { link: DeepLink }> = (props) => {
	const { link } = props;
	const [mode, setMode] = useState<"alumna" | "horario">(link.scheduleId && !link.studentId ? "horario" : "alumna");
	const [alumna, setAlumna] = useState<{ studentId?: number; enrollmentId?: number; vez: number }>({ studentId: link.studentId, enrollmentId: link.enrollmentId, vez: 0 });
	return (
		<div className="wau-pila">
			<div className="wau-seg" role="group">
				<button type="button" aria-pressed={mode === "alumna"} onClick={() => setMode("alumna")}>{S.unaAlumna}</button>
				<button type="button" aria-pressed={mode === "horario"} onClick={() => setMode("horario")}>{S.unHorario}</button>
			</div>
			{mode === "alumna"
				? <UnaAlumna key={"a" + alumna.vez} {...props} initialStudentId={alumna.studentId} initialEnrollmentId={alumna.enrollmentId} />
				: <UnHorario {...props} initialScheduleId={link.scheduleId}
					onActualizar={(studentId, enrollmentId) => { setAlumna({ studentId, enrollmentId, vez: alumna.vez + 1 }); setMode("alumna"); }} />}
		</div>
	);
};

export default ActualizarTab;
